import * as React from "react";
import Checkbox from "@mui/material/Checkbox";

export interface CustomCheckboxProps {
  id?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeConfig = {
  sm: 20,
  md: 24,
  lg: 28,
};

const CustomCheckbox = React.forwardRef<HTMLInputElement, CustomCheckboxProps>(
  ({ id, checked = false, onChange, disabled = false, size = "md", className }, ref) => {
    return (
      <Checkbox
        id={id}
        slotProps={{ input: { ref } }}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={className}
        sx={{
          color: "#d1d5db",
          padding: 0,
          "&.Mui-checked": { color: "#00C49A" },
          "& .MuiSvgIcon-root": { fontSize: sizeConfig[size] },
        }}
      />
    );
  }
);

CustomCheckbox.displayName = "CustomCheckbox";

export { CustomCheckbox };
